import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { LoginPage } from "~/pages/login.page";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    redirect: z
      .string()
      .optional()
      .refine((v) => !v || (v.startsWith("/") && !v.startsWith("//"))),
    // Better Auth redirects failed OAuth round-trips back here with a
    // machine-readable `error` code (and optional `error_description`).
    error: z.string().optional(),
    error_description: z.string().optional(),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.user) {
      throw redirect({ to: search.redirect ?? "/", replace: true });
    }
  },
  component: LoginPage,
});
